import type { ExcelAction } from "./types";
import { scanStrings } from "../../strings/scanner";
import { openStringsDialog } from "../dialog-host";

export const findStrings: ExcelAction = {
  id: "find-strings",
  label: "List all strings",
  description:
    "Scan every worksheet for text cells; show searchable, sortable, sheet-filterable table.",
  async run({ log }) {
    log("scanning text cells in all worksheets...");
    let strings;
    try {
      strings = await scanStrings();
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`scan failed: ${message}`, "error");
      return;
    }
    const sheetCount = new Set(strings.map((s) => s.sheetName)).size;
    log(
      `found ${strings.length.toLocaleString()} string cell(s) across ${sheetCount} sheet(s)`,
      strings.length > 0 ? "success" : "info"
    );
    try {
      await openStringsDialog(strings);
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`dialog failed: ${message}`, "error");
    }
  },
};
